<div class="export-dialog-container">
  <!-- Modal Header -->
  <div class="modal-header">
    <h2 class="modal-title">Export Project</h2>
    <button
      mat-icon-button
      class="close-button"
      (click)="cancel()"
      [disabled]="isExporting"
      aria-label="Close"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Modal Content -->
  <div class="modal-content">
    @if (error) {
      <div class="error-message">
        <mat-icon>error</mat-icon>
        <span>{{ error }}</span>
      </div>
    }

    <p class="dialog-description">
      Enter a password to encrypt the project secrets included in this export.
      You'll need this password if you want to import the project later.
    </p>

    <form [formGroup]="exportForm" (ngSubmit)="export()">
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Password</mat-label>
        <input
          matInput
          [type]="hidePassword ? 'password' : 'text'"
          formControlName="password"
          autocomplete="new-password"
        />
        <button
          mat-icon-button
          matSuffix
          type="button"
          (click)="hidePassword = !hidePassword"
          [attr.aria-label]="'Hide password'"
          [attr.aria-pressed]="hidePassword"
        >
          <mat-icon>{{
            hidePassword ? "visibility_off" : "visibility"
          }}</mat-icon>
        </button>
        @if (exportForm.get("password")?.hasError("required")) {
          <mat-error> Password is required </mat-error>
        }
        @if (exportForm.get("password")?.hasError("minlength")) {
          <mat-error> Password must be at least 6 characters </mat-error>
        }
      </mat-form-field>
    </form>
  </div>

  <!-- Modal Actions -->
  <div class="modal-actions">
    <button class="cancel-button" (click)="cancel()" [disabled]="isExporting">
      Cancel
    </button>
    <button
      class="export-button"
      (click)="export()"
      [disabled]="exportForm.invalid || isExporting"
    >
      @if (isExporting) {
        <mat-spinner diameter="20" class="button-spinner"></mat-spinner>
      }
      @if (!isExporting) {
        <span>Export</span>
      }
      @if (isExporting) {
        <span>Exporting...</span>
      }
    </button>
  </div>
</div>
